__turbopack_context__.v({
  "grid": "style-module-scss-module__vuLBsW__grid",
  "label": "style-module-scss-module__vuLBsW__label",
  "sub": "style-module-scss-module__vuLBsW__sub",
  "tile": "style-module-scss-module__vuLBsW__tile",
  "value": "style-module-scss-module__vuLBsW__value",
});
